import * as React from 'react';
import {Box, Typography} from '@mui/material';
import AndroidIcon from '@mui/icons-material/Android';

interface TargetDevicesCellProps {
    osType?: string | null;
    minBuildNumber?: number | null;
    maxBuildNumber?: number | null;
}

const getBuildRangeLabel = (minBuildNumber?: number | null, maxBuildNumber?: number | null) => {
    if (minBuildNumber == null && maxBuildNumber == null) return 'ALL';
    if (minBuildNumber != null && maxBuildNumber != null) {
        if (minBuildNumber === maxBuildNumber) {
            return `${minBuildNumber}`;
        }
        return `${minBuildNumber}-${maxBuildNumber}`;
    }
    if (minBuildNumber != null) {
        return `>= ${minBuildNumber}`;
    }
    return `<= ${maxBuildNumber}`;
};

export default function TargetDevicesCell({
    osType,
    minBuildNumber,
    maxBuildNumber
}: TargetDevicesCellProps) {
    const effectiveOsType = osType ?? 'android';
    const buildRangeLabel = getBuildRangeLabel(minBuildNumber, maxBuildNumber);

    return (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 0.75, width: '100%'}}>
            {effectiveOsType === 'ios'
                ? <img src='/ios_logo.png' width={18} height={18} alt='iOS'/>
                : <AndroidIcon sx={{fontSize: 18, color: '#3ddc84'}}/>
            }
            {buildRangeLabel && (
                <Typography variant="body2" noWrap>
                    {buildRangeLabel}
                </Typography>
            )}
        </Box>
    );
}
